import { getLocaleInfo } from '~/lang/locales'
import { fetchWithCache } from '../../../../utility/fetchWithCache'
import { FacetGroup } from '../../domain/facetGroups'

// Add type for API response
interface ApiFacetGroup {
  name: string
  slug: string
  facet_type: 'default' | 'ranked'
  facets: Array<{
    name: string
    slug: string
    is_pitch_type_facet: boolean
  }>
  hide_empty: boolean
  show_by_default: boolean
  group_order: number
}

export class FacetGroupRepositoryJson {
  async getFacetGroups(langCode: string): Promise<FacetGroup[]> {
    const fileName = getLocaleInfo(langCode).fileName
    const data = await fetchWithCache<ApiFacetGroup[]>(
      '/api/facetGroups?lang=' + fileName,
    )
    return data.map((group) => ({
      name: group.name,
      slug: group.slug,
      type: group.facet_type,
      facets: group.facets.map((facet) => ({
        name: facet.name,
        slug: facet.slug,
        is_pitch_type_facet: facet.is_pitch_type_facet,
      })),
      hideEmpty: group.hide_empty,
      showByDefault: group.show_by_default,
      order: group.group_order,
    }))
  }
}
